import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  message,
  Spin,
  Typography,
  List,
  Space,
  Divider,
  Tag,
} from "antd";
import {
  ExclamationCircleOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
} from "@ant-design/icons";
import axios from "axios";
import {
  HEADERS_EXPORT_BEN,
  POST_ACCEPT_WORK,
  POST_LAWSUIT_DETAIL,
} from "../../../API/apiUrls";
import dayjs from "dayjs";

const MemoCheckDoc = ({ open, close, record, handleLoad, status }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const [loading, setLoading] = useState(false);
  const { TextArea } = Input;
  const [remarkValue, setRemarkValue] = useState("");
  const [showNote, setShowNote] = useState(true);
  const toggleShowNote = () => setShowNote((prev) => !prev);
  const [dataNote, setDataNote] = useState();

  const loadData = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();

    try {
      const [lawsuitRes] = await Promise.all([
        axios.post(
          POST_LAWSUIT_DETAIL,
          {
            CONTNO: record.CONTNO,
            loanId: record.loanId,
            lawsuitId: record.lawsuitId,
          },
          {
            headers: HEADERS_EXPORT_BEN,
            signal: controller.signal,
          },
        ),
      ]);

      // Handle lawsuit response
      if (lawsuitRes?.data) {
        console.log("✅ lawsuitRes:", lawsuitRes.data);

        setDataNote(lawsuitRes.data.note || []);
        console.log(
          "✅ workLawsuitDoc:",
          lawsuitRes.data.lawsuit?.workLawsuitDoc,
        );
      } else {
        throw new Error("ไม่พบข้อมูลคดี");
      }

      // Handle leasing response
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("❌ Error loading data:", error);
        const errorMsg = error.response?.data?.message || error.message;
        message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [record]);

  useEffect(() => {
    if (open) {
      loadData();
    }
  }, [open, loadData]);

  const handleAccept = async (isAccept) => {
    const data = {
      loanId: record?.loanId,
      lawsuitId: record?.lawsuitId,
      userId: userId,
      flagAccept: isAccept,
      mark: remarkValue,
    };
    console.log(data);
    await accecptWork(data);
  };

  const accecptWork = async (dataLawsuit) => {
    console.log("Sending data...");
    setLoading(true);
    try {
      const response = await axios.post(POST_ACCEPT_WORK, dataLawsuit, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.status === 200) {
        console.log("Data sent successfully:", response.data);
        message.success("บันทึกข้อมูลสำเร็จ");
        handleLoad?.();
        close(false);
        setRemarkValue("");
      } else {
        throw new Error("ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error sending data:", error);
      const errorMsg = error.response?.data?.message || error.message;
      message.error(`เกิดข้อผิดพลาด: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const handdleClose = () => {
    close(false);
  };

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined
            style={{ color: "#faad14", marginRight: 8 }}
          />
          ตรวจรับเอกสาร
        </span>
      }
      open={open}
      onCancel={handdleClose}
      //   closable={false}
      //   maskClosable={false}
      footer={null}
      width={600}
    >
      <Spin spinning={loading} size="large" tip="Loading...">
        <div style={{ padding: "10px 0" }}>
          <p>1. สัญญา(ตัวจริง)</p>
          {/* <p>2. คู่มือ/โฉนด</p> */}
          {dataNote?.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <Divider orientation="left">
                <Space onClick={toggleShowNote} style={{ cursor: "pointer" }}>
                  <Typography.Text strong>หมายเหตุก่อนหน้า</Typography.Text>
                  <Tag color="blue">
                    {dataNote.length} รายการ{" "}
                    {showNote ? <UpSquareOutlined /> : <DownSquareOutlined />}
                  </Tag>
                </Space>
              </Divider>

              {showNote && (
                <List
                  style={{ marginBottom: 16 }}
                  bordered
                  dataSource={dataNote}
                  renderItem={(item) => (
                    <List.Item>
                      <List.Item.Meta
                        title={
                          <Space>
                            <Typography.Text strong>
                              {item.USERNAME}:
                            </Typography.Text>
                            <Typography.Text
                              type="secondary"
                              style={{ fontSize: 12 }}
                            >
                              {dayjs(item.CreatedAt).format("DD/MM/YYYY HH:mm")}
                            </Typography.Text>
                          </Space>
                        }
                        description={item.note}
                      />
                    </List.Item>
                  )}
                />
              )}
            </div>
          )}
          <TextArea
            placeholder="กรุณากรอกหมายเหตุ (กรณีไม่รับงาน)"
            value={remarkValue}
            onChange={(e) => setRemarkValue(e.target.value)}
            style={{ marginTop: 10 }}
            row={5}
            showCount
            maxLength={500}
          />

          <div style={{ marginTop: 20, textAlign: "right" }}>
            <Button
              danger
              onClick={() => handleAccept(false)}
              style={{ marginRight: 10, marginTop: 10 }}
              disabled={loading || remarkValue.trim() === ""}
            >
              ไม่รับงาน
            </Button>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => handleAccept(true)}
              disabled={loading}
            >
              รับงาน
            </Button>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default MemoCheckDoc;
